import { render, staticRenderFns } from "./ServiceDecline.vue?vue&type=template&id=22c0b0f8"
import script from "./ServiceDecline.vue?vue&type=script&lang=js"
export * from "./ServiceDecline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports